import { render, staticRenderFns } from "./PayRunBreakdown.vue?vue&type=template&id=6f8b509e&scoped=true"
import script from "./PayRunBreakdown.vue?vue&type=script&lang=js"
export * from "./PayRunBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b509e",
  null
  
)

export default component.exports